import { FilTextMediaBlockExtended } from './fil-text-media-block.component';

customElements.define('fil-text-media-block-g', FilTextMediaBlockExtended);
